import React from 'react';

/**
 * MarqueeBand — infinite-scrolling text band. Used between sections to add
 * kinetic rhythm and signal active brand/technical aesthetic.
 */
const MarqueeBand = ({
  items = [],
  speed = 40,
  reverse = false,
  className = '',
  itemClassName = '',
}) => {
  const safeItems = items.length ? items : ['AI'];
  // Triple-loop the items so the seamless loop has enough content
  const loop = [...safeItems, ...safeItems, ...safeItems];

  return (
    <div
      className={`relative overflow-hidden py-6 border-y border-white/[0.06] bg-[#0A0A0A] ${className}`}
      aria-hidden="true"
    >
      <div
        className="flex whitespace-nowrap"
        style={{
          animation: `marquee-band ${speed}s linear infinite ${reverse ? 'reverse' : ''}`,
          willChange: 'transform',
        }}
      >
        {loop.map((item, i) => (
          <span
            key={i}
            className={`mx-10 flex items-center gap-10 text-sm tracking-[0.25em] uppercase text-[#71717A] font-mono-tech ${itemClassName}`}
          >
            {item}
            <span className="w-1 h-1 rounded-full bg-[#FF6B00]/60" />
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee-band {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </div>
  );
};

export default MarqueeBand;
